module.exports = __webpack_public_path__ + "img/stempel-wilms.f5d92ed5.svg";